<template>
  <div class="row">
    <!-- Search bar -->
    <div v-if="showSearchBar" class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-2 col-md-6">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="Name"
                  type="text"
                  @input="searchField('name', $event.target.value)"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-6">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="ID Card"
                  type="text"
                  @input="searchField('id_card', $event.target.value)"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-6">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="Company Number"
                  type="text"
                  @input="searchField('company_number', $event.target.value)"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-6">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="IMO Number"
                  type="text"
                  @input="searchField('imo_number', $event.target.value)"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-6">
              <div class="input-group">
                <input
                  class="form-control"
                  placeholder="VAT Number"
                  type="text"
                  @input="searchField('vat_number', $event.target.value)"
                />
              </div>
            </div>
            <div class="col-lg-2 col-md-6 ms-auto">
              <a
                class="btn btn-sm btn-primary btn-block"
                href="javascript:void(0);"
                title=""
                >Search</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card">
        <div class="card-body table-responsive">
          <table
            class="table table-hover table-custom dataTable clients-js-data-table"
          >
            <thead>
              <tr>
                <th>Name</th>
                <th>ID Card</th>
                <th>Company Number</th>
                <th>IMO Number</th>
                <th>VAT Number</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(client, index) in filteredClients()"
                :key="index"
                class="cursor-pointer"
                @click="openClientDetails(client)"
              >
                <td>
                  {{ client.name }}
                </td>
                <td>{{ client.id_card }}</td>
                <td>{{ client.company_number }}</td>
                <td>{{ client.imo_number }}</td>
                <td>{{ client.vat_number }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientsTable",
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
    showSearchBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldFilters: [],
    };
  },
  methods: {
    openClientDetails(client) {
      let resolvedRoute = this.$router.resolve({
        name: "clients-show",
        params: { clientId: client.id },
      });
      window.open(resolvedRoute.href, "_blank", "noreferrer");
    },
    searchField: function (field, searchString) {
      let elem = this.fieldFilters.find((f) => f.field === field);
      if (elem !== undefined) {
        elem.searchString = searchString;
      } else {
        this.fieldFilters.push({
          field,
          searchString,
        });
      }
    },
    filteredClients: function () {
      let result = [...this.clients];
      this.fieldFilters.forEach((element) => {
        if (element.searchString) {
          result = result.filter((v) =>
            v?.[element.field]
              ?.toLowerCase()
              ?.includes(element.searchString.toLowerCase())
          );
        }
      });
      return result;
    },
    buildDataTable() {
      if (this.table) this.table.destroy();
      setTimeout(() => {
        this.table = window.jsDataTable(".clients-js-data-table");
      }, 250); // Just giving Vue some time to render the table
    },
  },
  watch: {
    clients() {
      this.buildDataTable();
    },
  },
};
</script>
